import { reactive, computed } from 'vue';
import axios from '@/services/axios';
import { normalizePermissions, permissionGranted } from '@/utils/permissions';

// Snapshot local da autorização existente; nunca reutiliza permissões de outra sessão.
export function useReceitasPermissions() {
  const state = reactive({ permissions: [], loaded: false, error: '' });
  let generation = 0;
  async function fetchPermissions() {
    const current = ++generation;
    state.loaded = false;
    state.error = '';
    state.permissions = [];
    try {
      const { data } = await axios.get('/auth/permissions');
      if (!Array.isArray(data?.permissions)) throw new Error('Resposta inválida de permissões.');
      if (current === generation) state.permissions = normalizePermissions(data?.permissions);
    } catch (error) {
      if (current === generation) state.error = [401, 403].includes(error.response?.status)
        ? 'Sessão expirada ou acesso negado. Entre novamente.'
        : 'Não foi possível carregar as permissões. Tente novamente.';
      // Falha de rede/autenticação não concede capacidades.
    } finally {
      if (current === generation) state.loaded = true;
    }
  }
  function hasPermission(permission) {
    const required = [permission];
    if (permission === 'excluir_receitas_planos') {
      required.push('alterar_matriculas');
    }
    return state.loaded && required.every(p => permissionGranted(state.permissions, p));
  }
  async function authorizeReceiptAction(permission) {
    await fetchPermissions();
    return hasPermission(permission);
  }
  return { fetchPermissions, hasPermission, authorizeReceiptAction, permissionsError: computed(() => state.error) };
}
